import React from "react";
import "../assets/css/styles.css";
import dash_2 from "../assets/images/dash_2.png";


const ImageSlider = () => {
  return (
    <div className="header-image">
      <img
        src={dash_2}
        alt="Quick Order Page"
        className="responsive-image"
      />
    </div>
  );
};

export default ImageSlider;
